import {
  baseFields,
  couponFields,
  discountedModifierFields,
  discountedProductFields,
  FormModel,
  onlineFlags,
  PosFields,
  templateConstraintFields,
} from '../index'

export function getFormModelKeys(): (keyof FormModel)[] {
  return [
    ...baseFields,
    'discount',
    'perceivedValue',
    ...onlineFlags,
    ...discountedModifierFields,
    ...discountedProductFields,
    'instoreRedemptionType',
    'availableCustomerSupport',
    'images',
    ...couponFields,
    'posFields',
    'productIds',
    ...templateConstraintFields,
  ]
}

export function getPosFieldKeys(): (keyof PosFields)[] {
  return [
    'instoreRedemptionType',
    'productIds',
    'instoreDiscountedModifierIds',
    'instoreDiscountedProductIds',
    'onlineDiscountedModifierIds',
    'onlineDiscountedProductIds',
    ...couponFields,
  ]
}
